// Login.jsx
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext"; // <- adjust path if needed
import "./RemoteTvLogin.css";

export default function Login() {
  const { isAuth, loading: authLoading, login } = useAuth();
  const [fullName, setFullName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const redirectTarget =
    new URLSearchParams(location.search).get("redirect") || "/rcu";

  // If already logged in, bounce away from /login
  useEffect(() => {
    if (!authLoading && isAuth) navigate(redirectTarget, { replace: true });
  }, [authLoading, isAuth, redirectTarget, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(fullName.trim(), username.trim(), password); // sets cookie on server
      navigate(redirectTarget, { replace: true });
    } catch (err) {
      setError(err?.message || "Login failed. Please try again.");
      setLoading(false);
    }
  };

  // Optional tiny guard while checking existing session
  if (authLoading) return null;

  return (
    <div className="rmtv-container">
      <main className="rmtv-card">
        <h1 className="rmtv-title">Remote TV Login</h1>
        <form className="rmtv-form" onSubmit={handleSubmit} autoComplete="off">
          <label htmlFor="username" className="rmtv-label">
            Full Name
          </label>
          <input
            id="username"
            type="text"
            className="rmtv-input"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            required
            autoFocus
          />
          <br />
          <br />

          <label htmlFor="username" className="rmtv-label">
            Username
          </label>
          <input
            id="username"
            type="text"
            className="rmtv-input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <label htmlFor="password" className="rmtv-label rmtv-label--mt">
            Password
          </label>
          <input
            id="password"
            type="password"
            className="rmtv-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button className="rmtv-button" type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign in"}
          </button>

          {error && (
            <div className="rmtv-error" role="alert">
              {error}
            </div>
          )}
        </form>
      </main>
    </div>
  );
}
